import {
  INITIATIVE_FE_COMPUTED_FIELD_NAME,
  INITIATIVE_STANDARD_FIELD_NAME,
  INITIATIVE_STANDARD_FIELDS
} from '@/constants/initiative'
import * as R from 'ramda'

/**
 * This function sort the passed fields(of initiative). Standard fields are kepts first, and then custom fields.
 * Among standard fields, the order is due_date, status, priority, owners
 * @param fields
 * @returns {*[]}
 */
export default fields => {
  let [standardFields, customFields] = R.partition(
    x => INITIATIVE_STANDARD_FIELDS.find(f => !x.id && f.name === x.name),
    fields
  )
  let [goalKrFields, remainingCustomFields] = R.partition(
    x =>
      [
        INITIATIVE_FE_COMPUTED_FIELD_NAME.GOAL,
        INITIATIVE_FE_COMPUTED_FIELD_NAME.KEY_RESULT,
        INITIATIVE_FE_COMPUTED_FIELD_NAME.PROJECT
      ].includes(x.name),
    customFields
  )
  const goal = goalKrFields.find(x => x.name === INITIATIVE_FE_COMPUTED_FIELD_NAME.GOAL)
  const kr = goalKrFields.find(x => x.name === INITIATIVE_FE_COMPUTED_FIELD_NAME.KEY_RESULT)
  const project = goalKrFields.find(x => x.name === INITIATIVE_FE_COMPUTED_FIELD_NAME.PROJECT)
  const dueDate = standardFields.find(x => x.name === INITIATIVE_STANDARD_FIELD_NAME.DUE_DATE)
  const status = standardFields.find(x => x.name === INITIATIVE_STANDARD_FIELD_NAME.STATUS)
  const priority = standardFields.find(x => x.name === INITIATIVE_STANDARD_FIELD_NAME.PRIORITY)
  const owners = standardFields.find(x => x.name === INITIATIVE_STANDARD_FIELD_NAME.OWNERS)
  standardFields = [goal, kr, project, dueDate, status, priority, owners].filter(Boolean)
  return [...standardFields, ...remainingCustomFields]
}
